import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { SET_CANCEL_CONFIRMATION_DIALOG } from "../../store/actionTypes/globalActionType";
import parser from "html-react-parser";

export const openCancelDialog = (dispatch, condition, handleCancel) => {
  if (condition) {
    dispatch({ type: SET_CANCEL_CONFIRMATION_DIALOG, payload: true });
  } else {
    handleCancel();
  }
};

export const CloseConfirmationDialog = ({ handleCancel }) => {
  const dispatch = useDispatch();
  const { cancelDialogOpen } = useSelector((state) => state.global);

  const { t: tCommon } = useTranslation();

  const handleCloseConfirmationDialog = () => {
    dispatch({ type: SET_CANCEL_CONFIRMATION_DIALOG, payload: false });
  };

  return (
    <>
      <Dialog maxWidth="sm" open={cancelDialogOpen}>
        <DialogContent>
          <DialogContentText
            sx={{
              mb: 2,
              textAlign: "center",
            }}
          >
            {parser(tCommon("cancelConfirmationText"))}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            fullWidth
            onClick={handleCloseConfirmationDialog}
          >
            {tCommon("noBtn")}
          </Button>

          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              handleCloseConfirmationDialog();
              handleCancel();
            }}
          >
            {tCommon("yesBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
